import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  ScrollView,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/DeviceActions";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import Loading from "../components/Loading";
import InputBase from "../nativeBase-ui/InputBase";
import { faEdit } from "../../assets/consts/faCharCodes";
import { HStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";

class GPIOFormScreen extends Component {
  constructor(props) {
    super(props);
    let {
      deviceId,
      deviceUId,
      taplifeControllerDeviceId,
      taplifeControllerDeviceUId,
      areaId,
      areaUId,
    } = this.props.navigation.state.params;
    this.state = {
      deviceId,
      deviceUId: deviceUId || null,
      taplifeControllerDeviceId,
      taplifeControllerDeviceUId: taplifeControllerDeviceUId || null,
      deviceName: "",
      deviceType: "",
      gpioPortNumber: 0,
      autoCloseSeconds: 0,
      isLockCapable: false,
      isLoading: true,
      accessToken: "",
      validation_deviceName_hasError: false,
      validation_gpioPortNumber_hasError: false,
      showingValidationErrors: false,
      showDoorlockOptions: false,
      validationErrors: [],
      showOnHomeScreen: "",
      areaId: areaId || null,
      areaUId: areaUId || null,
      secondGpioPortNumber: 0,
    };

    this.typesDropdownItems = [
      DeviceTypes.SIREN,
      DeviceTypes.LIGHT,
      DeviceTypes.POWER_SWITCH,
      DeviceTypes.DOORLOCK,
      DeviceTypes.DOORBELL,
      DeviceTypes.MOTION_SENSOR,
      DeviceTypes.DOOR_SENSOR,
      DeviceTypes.SENSOR_BINARY,
      DeviceTypes.LEAK_DETECTOR,
    ];
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  componentDidMount() {
    // get data from reducer using state.deviceId
    if (this.state.deviceId || this.state.deviceUId) {
      var model = {};
      for (var i in this.props.reducer.list) {
        // get model from reducer
        if (
          this.props.reducer.list[i].deviceId == this.state.deviceId ||
          (this.state.deviceUId &&
            this.props.reducer.list[i].deviceUId == this.state.deviceUId)
        ) {
          model = this.props.reducer.list[i];
          var _allowedTypes = [];
          try {
            if (
              Array.isArray(model.allowedTypes) &&
              model.allowedTypes.length > 0
            ) {
              _allowedTypes = model.allowedTypes;
            } else if (
              model.device &&
              Array.isArray(model.device.allowedTypes) &&
              model.device.allowedTypes.length > 0
            ) {
              _allowedTypes = model.device.allowedTypes;
            }
          } catch (error) {}

          if (_allowedTypes.length > 0) {
            this.typesDropdownItems = _allowedTypes;
          }

          var autoCloseSeconds = 0,
            showDoorlockOptions = false,
            isLockCapable = false,
            gpioPortNumber = model.gpioPortNumber,
            secondGpioPortNumber = model.gpioPortNumber;
          if (model.deviceType == DeviceTypes.DOORLOCK) {
            console.log("model in gpio form", model);
            autoCloseSeconds = model.autoCloseSeconds || 0;
            gpioPortNumber = model.unlockerGPIOPortNumber || 0;
            secondGpioPortNumber = model.lockerGPIOPortNumber || 0;
            isLockCapable = model.isLockCapable || false;
            showDoorlockOptions = true;
          }

          this.setState({
            deviceName: model.deviceName,
            deviceType: model.deviceType,
            gpioPortNumber,
            secondGpioPortNumber,
            showOnHomeScreen: model.showOnHomeScreen,
            autoCloseSeconds,
            showDoorlockOptions,
            isLockCapable,
          });
          break;
        }
      }
    } else {
      this.setState({ deviceType: this.typesDropdownItems[0] });
    }
    this.setState({
      accessToken: this.props.appReducer?.currentServer.accessToken,
      isLoading: false,
    });
  }

  goBack = () => {
    // this.props.navigation.navigate("DeviceList", { areaId: this.state.areaId });

    if (this.props.navigation) {
      // go back to prev screen
      this.props.navigation.goBack();

      // callback
      this.props.navigation.state.params.onGoBack &&
        this.props.navigation.state.params.onGoBack(this.state.deviceType);

      return false;
    }
  };

  goToDeviceLog = () => {
    this.props.navigation.navigate("DeviceLogs", {
      deviceId: this.state.deviceId,
      deviceUId: this.state.deviceUId,
    });
  };

  save = () => {
    var model = {
      areaId: this.state.areaId,
      areaUId: this.state.areaUId,
      buildingId: this.props.appReducer.currentBuilding.buildingId,
      deviceId: this.state.deviceId,
      deviceUId: this.state.deviceUId,
      deviceName: this.state.deviceName,
      deviceType: this.state.deviceType,
      taplifeControllerDeviceId: this.state.taplifeControllerDeviceId,
      taplifeControllerDeviceUId: this.state.taplifeControllerDeviceUId,
      gpioPortNumber: this.state.gpioPortNumber,
      showOnHomeScreen: this.state.showOnHomeScreen,
      secondGpioPortNumber: 0,
    };

    if (model.deviceType == DeviceTypes.DOORLOCK) {
      model.secondGpioPortNumber = this.state.secondGpioPortNumber;
      model.isLockCapable = this.state.isLockCapable;
      model.AutoCloseSeconds = this.state.autoCloseSeconds;
    }

    // validation
    let errors = [];
    if (!model.deviceName) {
      errors.push(
        `${translate("device.deviceName")} ${translate("app.isRequired")}`
      );
      this.setState({ validation_deviceName_hasError: true });
    }
    if (!model.deviceType) {
      errors.push(
        `${translate("device.deviceType")} ${translate("app.isRequired")}`
      );
    }
    if (!model.gpioPortNumber) {
      errors.push(
        `${translate("device.gpioPortNumber")} ${translate("app.isRequired")}`
      );
      this.setState({ validation_gpioPortNumber_hasError: true });
    }

    if (errors.length > 0) {
      this.showValidationAlert(errors);
      return;
    }
    // end of validation

    // if valid
    if (model.deviceId || model.deviceUId) {
      this.props.update(model, this.state.accessToken);
    } else {
      this.props.add(model, this.state.accessToken);
    }
    this.goBack();
  };

  showValidationAlert = (errors = []) => {
    this.setState({
      showingValidationErrors: true,
      validationErrors: [...errors],
    });
  };

  dismissValidationAlert = () => {
    this.setState({
      showingValidationErrors: false,
      validationErrors: [],
    });
  };

  handleDeviceTypeChange = (v) => {
    var showDoorlockOptions = false;
    if (v == DeviceTypes.DOORLOCK) {
      showDoorlockOptions = true;
    }
    this.setState({
      deviceType: v,
      showDoorlockOptions,
    });
  };

  render() {
    if (this.state.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else {
      const screenTitle =
        this.state.deviceId || this.state.deviceUId
          ? this.state.deviceName || translate("app.noName")
          : translate("device.defineNewDevice");
      return (
        <KeyboardAvoidingView
          behavior="height"
          style={{ flex: 1 }}
          enabled={true}
          keyboardVerticalOffset={80}
        >
          <ScrollView style={style.container}>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ color: Theme.COLORS.MUTED, flex: 1 }}>
                {this.state.areaName} : {translate("device.devices")} :{" "}
              </Text>
            </View>
            <Text style={style.screenTitle}>{screenTitle}</Text>
            <InputBase
              isInvalid={this.state.validation_deviceName_hasError}
              label={translate("device.deviceName")}
              onChangeText={(txt) =>
                this.setState({
                  deviceName: txt,
                  validation_deviceName_hasError: txt.length == 0,
                })
              }
              value={this.state.deviceName}
              icon={faEdit}
            />
            <View style={{ marginVertical: 20 }}>
              <InputBase
                keyboardType="numeric"
                isInvalid={this.state.validation_gpioPortNumber_hasError}
                label={translate("device.gpioPortNumber")}
                onChangeText={(txt) => {
                  var n = Number(txt) || 0;
                  this.setState({
                    gpioPortNumber: n,
                    validation_gpioPortNumber_hasError: !n,
                  });
                }}
                value={this.state.gpioPortNumber.toString()}
                icon={faEdit}
              />
            </View>
            <Select
              label={translate("device.deviceType")}
              data={this.typesDropdownItems.map((v) => {
                return { value: v, label: translate(`deviceGroup.${v}`) };
              })}
              value={this.state.deviceType || ""}
              onChangeText={(value, index, data) => {
                this.handleDeviceTypeChange(value);
              }}
            />

            {this.state.showDoorlockOptions && (
              <View>
                <InputBase
                  containerStyle={{ marginVertical: 20 }}
                  keyboardType="numeric"
                  label={translate("device.autoCloseSeconds")}
                  onChangeText={(txt) =>
                    this.setState({
                      autoCloseSeconds: Number(txt) || 0,
                    })
                  }
                  value={
                    (Number(this.state.autoCloseSeconds) &&
                      this.state.autoCloseSeconds.toString()) ||
                    ""
                  }
                  icon={faEdit}
                />

                <Switch
                  label={translate("device.isLockCapable")}
                  isOn={this.state.isLockCapable}
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  size="small"
                  onToggle={(v) => {
                    this.setState({
                      isLockCapable: !this.state.isLockCapable,
                    });
                  }}
                  animationSpeed={0}
                />

                {this.state.isLockCapable && (
                  <View style={{ marginTop: 20 }}>
                    <InputBase
                      keyboardType="numeric"
                      label={translate("device.lockerGpioPortNumber")}
                      onChangeText={(txt) =>
                        this.setState({
                          secondGpioPortNumber: Number(txt) || 0,
                        })
                      }
                      value={
                        (Number(this.state.secondGpioPortNumber) &&
                          this.state.secondGpioPortNumber.toString()) ||
                        ""
                      }
                      icon={faEdit}
                    />
                  </View>
                )}
              </View>
            )}

            <View
              style={{
                marginTop: 20,
              }}
            >
              <Switch
                label={translate("device.showOnHomeScreen")}
                isOn={this.state.showOnHomeScreen}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  this.setState({
                    showOnHomeScreen: !this.state.showOnHomeScreen,
                  });
                }}
                animationSpeed={0}
              />
            </View>

            <HStack space={2} style={{ marginVertical: 10 }}>
              <ArButton
                color="primary"
                onPress={() => this.save()}
                style={{ flex: 1 }}
              >
                {translate("app.save")}
              </ArButton>
              <ArButton
                color="muted"
                variant="outline"
                onPress={() => this.goBack()}
                style={{ flex: 1 }}
              >
                {translate("app.goBack")}
              </ArButton>
            </HStack>
            {this.state.deviceId > 0 && (
              <ArButton
                color="success"
                style={{ marginBottom: 10, width: "100%" }}
                onPress={() => this.goToDeviceLog()}
              >
                {translate("area.logs")}
              </ArButton>
            )}
          </ScrollView>
          {/** validation alert */}
          {this.state.showingValidationErrors && (
            <AlertDialogBase
              isOpen={true}
              cancelText={translate("app.close")}
              cancelVariant="outline"
              onClose={() => this.dismissValidationAlert()}
            >
              <Text>{" - " + this.state.validationErrors.join("\r\n - ")}</Text>
            </AlertDialogBase>
          )}
        </KeyboardAvoidingView>
      );
    }
  }
}

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  inputLabel: {
    fontWeight: "500",
    fontSize: 15.4,
    marginBottom: 4,
  },
  CheckBox: {
    alignSelf: "center",
    padding: 0,
    margin: 0,
    width: 16,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (device, accessToken) =>
      dispatch(Actions.AddGPIO(device, accessToken)),
    update: (device, accessToken) =>
      dispatch(Actions.UpdateGPIO(device, accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GPIOFormScreen);
